import React from 'react'
import type { AvatarProps } from '@ztechapps/webui.util'
import { Avatar } from '@ztechapps/webui.util'
import type { UserProfile } from '@ztechapps/common.contract'

export type UserAvatarProps = { name?: string; profile?: Partial<UserProfile>; src?: string } & Partial<AvatarProps>
export const UserAvatar = ({ profile, ...rest }: UserAvatarProps) => {
  let picture = profile?.picture

  //if is using the default picture, just ignore it and use the name
  const regex = /dft-customer\.jpg/
  const containsDefault = regex.test(picture)
  if (containsDefault) {
    picture = null
  }
  return <Avatar name={profile?.name} src={picture} {...rest} />
}
